import { inject, Provider, provideEnvironmentInitializer, EnvironmentProviders } from '@angular/core';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import {
  SOFTLINE_FEATURE_TRANSLATION,
  TranslationStore,
} from '@softline/ui-core';
import {
  ApplicationStore,
  getModuleGroupById,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  SOFTLINE_DEFINITION_FREIGABE_DETAIL,
  SOFTLINE_DEFINITION_FREIGABE_LIST,
  SOFTLINE_PERMISSIONS_FREIGABE,
} from './freigabe.shared';
import { freigabeRoutes } from './freigabe.routes';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic';
import { default as listDefinition } from './definitions/freigabe-list.definition.json';
import { default as detailDefinition } from './definitions/freigabe-details.definition.json';
import { provideFreigabeGlobals } from './freigabe.globals';

export function provideFreigabeModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'freigabe',
        title: '#FREIGABE.TITLE',
        icon: 'fa-regular fa-file-invoice-dollar',
        route: '/freigabe',
        permission: SOFTLINE_PERMISSIONS_FREIGABE,
        group: getModuleGroupById(4),
      },
      withSoftAppsModuleRoutes({ app: freigabeRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
    ...provideFreigabeGlobals(),
  ];
}

export const freigabeProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'freigabe',
          language: 'de',
          translations: de,
        }
      );
      store.commit(
        SOFTLINE_FEATURE_APPLICATIONS,
        ApplicationStore.mutations.add,
        {
          name: '#FREIGABE.TITLE',
          icon: 'fa-regular fa-file-invoice-dollar',
          route: '/freigabe',
          permission: SOFTLINE_PERMISSIONS_FREIGABE,
          group: getModuleGroupById(4), // Finanzbuchhaltung
        }
      );
    }),
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_FREIGABE_LIST,
      definition: listDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_FREIGABE_DETAIL,
      definition: detailDefinition,
    },
    multi: true,
  },
];
